import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { IMAGES } from '../data/content';
import { Reveal, Eyebrow } from './Reveal';

export const InteriorBand = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const y = useTransform(scrollYProgress, [0, 1], ['-10%', '10%']);

  return (
    <section ref={ref} data-testid="interior-band" className="relative h-[55vh] min-h-[420px] overflow-hidden">
      <motion.img
        src={IMAGES.interior}
        alt="Luxury kitchen at dusk"
        style={{ y, scale: 1.18 }}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-espresso/60" />
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-5 text-center">
        <Eyebrow>The Invicto Standard</Eyebrow>
        <Reveal>
          <p className="mt-5 max-w-3xl font-serif text-3xl font-light italic leading-snug text-cream sm:text-4xl lg:text-5xl">
            "Every detail considered. Every line intentional. Every finish, final."
          </p>
        </Reveal>
      </div>
    </section>
  );
};
